import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, Table, TableBody, TableCell, TableHead, TableRow, Card, IconButton, } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import * as Yup from 'yup';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from "../common/CustomButton";
import CustomTextField from "../common/CustomTextField";
import CustomTextarea from "../common/CustomTextarea";
import { genericPost } from '../../services/authServices';
import CustomAutocomplete from "../common/CustomAutoComplete";
import CustomPrefixSuffixField from "../common/CustomPrefixSuffixField";
import CustomStyle from "../common/CustomStyle";
import { t } from "../../constants/translationHelper";
import axios from "axios";
import { getClientCompany, getFCLData, } from "../../services/CommonServices";

import { getRoundAmount } from "../../services/CommonServices";
import { convertNumberToWords } from "../../services/apiServices";
import {
  GET_PRODUCTS_LIST,
  READ_ORDER_PLANNING,
  UPDATE_ORDER_PLANNING,
  DELETE_ORDER_PLANNING_PARTICULAR
} from "../../services/apiRoutes";
import { companyDateFormat } from "../../services/apiServices";
import CustomCardView from "../common/CustomCardView";
import DetailsParticulars from "../common/DetailsPage/DetailsParticulars";


const ViewOrderPlanning = ({ handleClose, setMessage, fetchData,   selectedId, statusList, orderTypeList, }) => {
  const [productsList, setProducts] = useState([]);
  const [clientCompany, setClientCompany] = useState([]);
  const [fclData, setFCLData] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [dataParticular, setDataParticular] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [amountData, setAmountData] = useState("");
  const [grandTotal, setGrandTotal] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [amountText, setAmountText] = useState(0);

  const amountInWords = convertNumberToWords(amountText || 0);

  useEffect(() => {
    if (!selectedId) return;
    const fetchOrderPlanning = async () => {
      try {
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.get(READ_ORDER_PLANNING(selectedId), {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const order = response.data.orderPlanning;

        const symbol = order?.currency?.currency_symbol || "";
        const symbolName = order?.currency?.currency_name || "";

        const particulars = (order.particulars || []).map(item => ({
          productName: item.products?.productName || "",
          qty: Number(item.qty || 0),
          rate: `${symbol} ${Number(item.rate || 0).toFixed(2)}`,
          unit: item.productsUnit?.unitName || "",
          amount: Number(item.qty || 0) * Number(item.rate || 0),
          amountDisplay: `${symbol} ${(Number(item.qty || 0) * Number(item.rate || 0)).toFixed(2)}`,
          container: item.noOfContainer || "",
          shippingMark: item.shippingMark || "",
          containerSize: item.fcl?.fclName || "",


        }));

        const totalQuantity = particulars.reduce(
          (sum, item) => sum + Number(item.qty),
          0
        );

        const totalAmount = particulars.reduce(
          (sum, item) => sum + Number(item.amount),
          0
        );

        const roundedAmount = getRoundAmount(totalAmount);

        setData(order);
        setDataParticular(particulars);
        setTotalQty(totalQuantity);

        setAmountData(`${symbol} ${roundedAmount.toFixed(2)}`);
        setGrandTotal(`${symbol} ${roundedAmount.toFixed(2)}`);

        setAmountText(roundedAmount);
        setCurrencyName(symbolName);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchOrderPlanning();
  }, [selectedId]);

  const values = {
    company: data?.client?.clientCompanyName || "",
    orderNo: data?.orderNo || "",
    shipmentId: data?.shipmentId || "",
    orderType:
      orderTypeList.find(
        item => item.id === String(data?.commanShipmentId)
      )?.title || "",
    status:
      statusList.find(
        item => item.id === String(data?.status)
      )?.title || "",
    currency:
      `${data?.currency?.currency_symbol || ""} ${data?.currency?.currency_name || ""}`,
    date: companyDateFormat(data?.date),
    etd: companyDateFormat(data?.eTD),
    eta: companyDateFormat(data?.eTA),
    notes: data?.notes || "",
  };

  const labels = [
    {
      key: "company",
      label: "Company",
      md: 4
    },

    {
      key: "orderType",
      label: "Order Type",
      md: 4
    },
    {
      key: "orderNo",
      label: "Order No",
      md: 4
    },
    {
      key: "status",
      label: "Status",
      md: 4
    },
    {
      key: "currency",
      label: "Currency",
      md: 4
    },
    {
      key: "date",
      label: "Date",
      md: 4
    },
    {
      key: "etd",
      label: "Expected ETD",
      md: 4
    },
    {
      key: "eta",
      label: "Expected ETA",
      md: 4
    },

  ];
  const particularsColumns = [

    {
      id: "productName",
      label: "Product",
      accessor: "productName"
    },
    {
      id: "qty",
      label: "Qty",
      accessor: "qty"
    },
    {
      id: "rate",
      label: "Rate",
      accessor: "rate"
    },
    {
      id: "unit",
      label: "Unit",
      accessor: "unit"
    },
    {
      id: "amount",
      label: "Amount",
      accessor: "amountDisplay"
    },
    {
      id: "container",
      label: "Container",
      accessor: "container"
    },
    {
      id: "containerSize",
      label: "Container Size",
      accessor: "containerSize"
    },
    {
      id: "shippingMark",
      label: "Shipping Mark",
      accessor: "shippingMark"
    }

  ];

  const footerData = [
    {
      label: "Total",
      footerValue: "",
      colSpan: 1
    },
    {
      label: "",
      footerValue: totalQty,
      align: "center"
    },
    {
      label: "",
      footerValue: "",
      colSpan: 5
    },
    {
      label: "",
      footerValue: grandTotal,
      align: "right"
    }
  ];
  return (
    <Box sx={{ mx: 'auto', mt: 0 }}>
      <Formik
        initialValues={values}
        enableReinitialize
      >
        {() => (
          <Form>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#212529" }}>
                  {t("Order Planning")}
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Box>
                  <IconButton aria-label="close" onClick={handleClose}>
                    <CloseIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Divider />
            <Grid container spacing={0} sx={{ px: "0%" }}>
              <Grid item xs={12} md={12} >
                <CustomCardView
                  title="Bill To"
                  label={labels}
                  data={values}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                    {t("Particulars")}
                  </Typography>
                </Box>
                <DetailsParticulars
                  title={'Particulars'}
                  columns={particularsColumns}
                  data={dataParticular}
                  footerData={footerData}
                />
              </Grid>
              <Grid item xs={7}>
                <br />
                <Box>
                  <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                    {t("In Words")}
                  </Typography>
                  <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "uppercase" }}>
                    {currencyName} {amountInWords}
                  </Typography>
                </Box>
                <br />


                <Box sx={{ pt: 5 }}>
                  <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                    {t("Note")} :
                  </Typography>
                  <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "capitalize" }}>
                    {values.notes || ""}

                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={5}>
                <br />
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                    {t("Summary")}
                  </Typography>
                </Box>
                <Card sx={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 1, maxWidth: 400 }} variant="outlined">
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>{t("Total Quantity")}:</Typography>
                    <Typography>{totalQty}</Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>{t("Amount")}:</Typography>
                    <Typography> {amountData}</Typography>
                  </Box>

                  <Divider sx={{ my: 0 }} />

                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography fontWeight="bold">{t("Grand Total")}:</Typography>
                    <Typography fontWeight="bold">{amountData}</Typography>
                  </Box>
                </Card>
              </Grid>

            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ViewOrderPlanning;
